import useWindowSize from 'components/util/useWindowSize'
import LeftRobotCard from 'components/cards/new/common/LeftRobotCard'
import CircleCheck from 'components/icons/CircleCheck'

const support = [
  '99.99% SLA and live uptime monitoring',
  'Local support 9am–6pm AEST, Monday–Friday',
  'Real-time metrics, dashboards, and financial tracking',
  'Dedicated developer integration assistance',
]

const EnterpriseLevelSupport = () => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm with mail in Sydney',
        desktop: {
          dimensions: {
            height: 540,
            width: 620,
          },
          src: '/images/new/au/robot-arm-mail-small.png',
        },
        mobile: {
          dimensions: {
            height: 371,
            width: 400,
          },
          src: '/images/new/au/vo-plus-sydney.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '40%' : '100%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pb-12 pe-lg-12 py-lg-25'>
        <h3 className='fw-semibold fs-fluid-48-52 lh-105'>
          <span className='color-pink2'>Enterprise-Level </span>Support
        </h3>
        <ul className='list-unstyled d-flex flex-column gap-4'>
          {support.map((text, index) => (
            <li
              key={index}
              className='fs-fluid-18-26 fw-semibold lh-134 d-flex'
            >
              <CircleCheck
                fill='#30DB5B'
                className='me-2 mt-lg-2 flex-shrink-0 mt-1'
              />
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </LeftRobotCard>
  )
}

export default EnterpriseLevelSupport
